// Security & Audit - the customer-facing trust surface: full audit trail of
// every action in the platform (uploads, views, edits, exports, settings,
// support-access grants). This stream doubles as SOC 2 evidence.
import React, { useEffect, useState } from 'react';
import {
  Box, Card, CardContent, Chip, Grid, Paper, Table, TableBody, TableCell,
  TableHead, TableRow, Typography,
} from '@mui/material';
import lpsService from '../services/lpsService';

const TYPE_COLOR = (t) =>
  t.startsWith('auth') ? 'info'
    : t.includes('deleted') || t.includes('denied') || t.includes('failed') ? 'error'
      : t.startsWith('support') ? 'warning' : 'default';

export default function LpsSecurityPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    lpsService.auditLog().then(setItems).catch(() => {});
    const t = setInterval(() => lpsService.auditLog().then(setItems).catch(() => {}), 5000);
    return () => clearInterval(t);
  }, []);

  const counts = items.reduce((acc, e) => {
    const k = e.type.split('.')[0];
    acc[k] = (acc[k] || 0) + 1;
    return acc;
  }, {});

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700}>Security & Audit</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Every action in the platform is recorded — ids and counts only, never
        content. LPS has no access to this deployment unless you grant it.
      </Typography>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        {Object.entries(counts).map(([k, n]) => (
          <Grid item xs={6} sm={3} md={2} key={k}>
            <Card variant="outlined">
              <CardContent sx={{ textAlign: 'center', py: 1.5 }}>
                <Typography variant="h5" fontWeight={800}>{n}</Typography>
                <Typography variant="caption" color="text.secondary" textTransform="uppercase">
                  {k} events
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>When (UTC)</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Actor</TableCell>
              <TableCell>Target</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((e, i) => (
              <TableRow key={i} hover>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{(e.at || '').slice(0, 19).replace('T', ' ')}</TableCell>
                <TableCell><Chip size="small" label={e.type} color={TYPE_COLOR(e.type)} /></TableCell>
                <TableCell>{e.actor_id || '—'}</TableCell>
                <TableCell>{e.target_id || '—'}</TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {JSON.stringify(e.meta || {})}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
            {!items.length && (
              <TableRow><TableCell colSpan={5}>
                <Typography sx={{ p: 3 }} color="text.secondary" align="center">No events yet.</Typography>
              </TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
